function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

let lastInputWasTouch = false;
let usingMouseOnTouchDevice = false;

function updateInputMethod(event) {
  if (event.type.startsWith('touch')) {
    lastInputWasTouch = true;
    usingMouseOnTouchDevice = false;
  } else if (event.type === 'mousemove' || event.type === 'mousedown') {
    if (isTouchDevice() && !lastInputWasTouch) {
      usingMouseOnTouchDevice = true;
    } else if (lastInputWasTouch) {
      usingMouseOnTouchDevice = true;
      setTimeout(() => {
        lastInputWasTouch = false;
      }, 1000);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const menuContainer = document.querySelector('.header__inline-menu');
  const menuItems = document.querySelectorAll('.header__inline-menu details');

  if (!menuContainer) return;

  document.addEventListener('touchstart', updateInputMethod, { passive: true });
  document.addEventListener('touchend', updateInputMethod, { passive: true });
  document.addEventListener('mousemove', updateInputMethod, { passive: true });
  document.addEventListener('mousedown', updateInputMethod, { passive: true });

  menuContainer.addEventListener('click', handleEvent);
  menuContainer.addEventListener('pointerdown', handleEvent);
  menuContainer.addEventListener('pointerup', handleEvent);
  menuContainer.addEventListener('mouseover', handleEvent);

  menuItems.forEach((item) => {
    item.addEventListener('mouseleave', () => {
      if (!isTouchDevice() || usingMouseOnTouchDevice) {
        item.removeAttribute('open');
      }
      document.body.classList.remove('js-mega-menu-active');
    });
  });

  function handleEvent(event) {
    const item = event.target.closest('details');
    if (!item || !menuContainer.contains(item)) return;

    if (event.type === 'touchstart') {
      lastInputWasTouch = true;
      usingMouseOnTouchDevice = false;
      if (!isTouchDevice()) event.preventDefault();
      item.setAttribute('open', true);
      document.body.classList.add('js-mega-menu-active');
    }

    if (event.type === 'touchend') {
      if (!isTouchDevice()) event.preventDefault();
      item.removeAttribute('open');
      document.body.classList.remove('js-mega-menu-active');
    }

    if (event.type === 'mouseover' && (!isTouchDevice() || usingMouseOnTouchDevice)) {
      item.setAttribute('open', true);
      document.body.classList.add('js-mega-menu-active');
    }
  }
});
